import { render, staticRenderFns } from "./customerinquire.vue?vue&type=template&id=ffef4aac&"
import script from "./customerinquire.vue?vue&type=script&lang=js&"
export * from "./customerinquire.vue?vue&type=script&lang=js&"
import style0 from "./customerinquire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports